export default {};

/**
 * @description Единицы измерения цен
 * @type Array
 */
export const unitOptions = [
  {
    value: 'за 1 зуб',
    title: 'за 1 зуб',
  },
  {
    value: 'за 1 челюсть',
    title: 'за 1 челюсть',
  },
  {
    value: 'за обе челюсти',
    title: 'за обе челюсти',
  },
  {
    value: '1 шт.',
    title: '1 шт.',
  },
];
